export enum SessionStorageEnum {
  AUDIT_INFO_KEY = '__auditInfo',
  CONTEXT_DATA = 'contextData',
}
